import { labelTypeMixin } from "~/mixins/inputs/checkbox.js"
import validationChildMixin from "~/mixins/validationChild"

export default {
  mixins: [validationChildMixin, labelTypeMixin],
  computed: {
    innerValue: function () {
      if (typeof this.value === "boolean")
        return this.invert ? !this.value : this.value
      else
        return this.invert
          ? !this.value.includes(this.valuename)
          : this.value.includes(this.valuename)
    },
    boxClass: function () {
      return {
        [this.visual]: true,
        disabled: this.disabled,
        uncertain: this.uncertain,
        checked: this.innerValue,
        error: !this.validity,
      }
    },
    labelClass: function () {
      const ret = {}

      if (typeof this.labeltype === "string") ret[this.labeltype] = true
      else if (typeof this.labeltype === "object") {
        for (var i = this.labeltype.length - 1; i >= 0; i--) {
          const className = this.labeltype[i]

          ret[className] = true
        }
      }
      ret.disabled = this.disabled
      ret.error = !this.validity
      return ret
    },
  },
  methods: {
    toggle: function () {
      if (!this.disabled && !this.sofdisabled) {
        this.$emit("change")
        if (typeof this.value === "boolean") this.$emit("input", !this.value)
        else if (typeof this.value === "object") {
          const index = this.value.indexOf(this.valuename)
          const newarr = [...this.value]

          if (index !== -1) newarr.splice(index, 1)
          else newarr.push(this.valuename)
          this.$emit("input", newarr)
        }
      }
    },
  },
  props: {
    value: {
      type: [Array, Boolean],
      required: true,
    },
    valuename: {
      type: [String, Number],
      required: false,
    },
    invert: {
      default: function () {
        return false
      },
      type: Boolean,
    },
    disabled: {
      default: function () {
        return false
      },
      type: Boolean,
    },
    sofdisabled: {
      default: function () {
        return false
      },
      type: Boolean,
    },
    uncertain: {
      default: function () {
        return false
      },
      type: Boolean,
    },
    label: {
      required: false,
      type: [String, Number],
    },
    rightbox: {
      default: function () {
        return false
      },
      type: Boolean,
    },
    visual: {
      type: String,
      default: function () {
        return "main"
      },
      validator: function (value) {
        return ["main", "secondary", "grey"].includes(value)
      },
    },
  },
}
